import type { ApiUnit } from "@/hooks/useProjects";
import type { Unit } from "@/types/units";

const PLACEHOLDER = "/logo.png";

/** Adapt a backend unit (with project snapshot) to the detail/compare Unit shape (price-free). */
export function apiToUnit(u: ApiUnit): Unit {
  return {
    code: u.code,
    project: u.project?.name ?? { ar: "", en: "" },
    name: u.name,
    status: u.status,
    priceEGP: 0, // prices are intentionally not shown on the site
    area: u.area ?? 0,
    rooms: u.beds ?? 0,
    baths: u.baths ?? 0,
    parking: 0, // not tracked in the backend unit schema
    view: u.view ?? { ar: "", en: "" },
    images: (() => {
      const imgs = (u.images ?? []).filter(Boolean);
      if (imgs.length) return imgs;
      return u.thumbnail ? [u.thumbnail] : [PLACEHOLDER];
    })(),
  };
}
